import { ExploreTestID, TextTestID } from "@/constants/TestID";
import Button from "@/ui/core/buttons/Button";
import { FAIconName } from "@/ui/core/Icon/IconDefinitions";
import BaseCard from "@/ui/layout/BaseCard";
import EmptyListContent from "@/ui/layout/list/EmptyListContent";
import { VStack } from "@/ui/layout/Stacks";
import { joinTestIDs } from "@/utils/string.util";

interface YourGroupsEmptyListCardProps {
  forWhom?: string;
  onButtonPress?: () => void;
  shouldShowSearchGroups?: boolean;
}
const DefaultForWhom = "You";

const EmptyCardConstants = {
  buttonTitle: "Search groups",
  description:
    "Groups are included in Equip treatment and provide a safe place to share, listen, and learn together throughout treatment.",
  title: (forWhom: string) =>
    `${forWhom} ${forWhom === DefaultForWhom ? "haven't" : "hasn't"} registered for any groups`,
} as const;

const baseTestID = ExploreTestID.YourGroupsEmptyListCard;

const YourGroupsEmptyListCard = ({
  forWhom = DefaultForWhom,
  onButtonPress,
  shouldShowSearchGroups,
}: YourGroupsEmptyListCardProps) => (
  <BaseCard
    isBorderDashed
    shouldHideOverflow={false}
    testID={joinTestIDs(baseTestID, TextTestID.Card)}
  >
    <VStack alignItems="flex-start" gap={8}>
      <EmptyListContent
        paragraphs={[EmptyCardConstants.description]}
        testID={baseTestID}
        title={EmptyCardConstants.title(forWhom)}
      />
      {shouldShowSearchGroups && onButtonPress && (
        <Button
          leftIcon={FAIconName.Search}
          onPress={onButtonPress}
          size="small"
          testID={joinTestIDs(baseTestID, "button")}
          title={EmptyCardConstants.buttonTitle}
          variant="tertiary"
        />
      )}
    </VStack>
  </BaseCard>
);

export { EmptyCardConstants };
export default YourGroupsEmptyListCard;
